let scriptPromise = null;

export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.onload = () => resolve(true);
    s.onerror = () => { scriptPromise = null; resolve(false); };
    document.body.appendChild(s);
  });
  return scriptPromise;
}

// Opens Razorpay Checkout for a server-created order. Resolves with the
// handler payload on success, rejects on dismiss / failure.
export async function openCheckout({ key_id, amount, currency = 'INR', order_id, name, description, prefill = {}, theme = '#1E3A8A' }) {
  const ok = await loadRazorpay();
  if (!ok) throw new Error('Could not load Razorpay. Check your internet connection.');
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: key_id, amount, currency, order_id, name, description, prefill,
      theme: { color: theme },
      handler: (res) => resolve(res),
      modal: { ondismiss: () => reject(new Error('Payment cancelled')) },
    });
    rzp.on('payment.failed', (res) => reject(new Error(res?.error?.description || 'Payment failed')));
    rzp.open();
  });
}
